<div class="main-container mat-app-background">
  <lfw-navigation-toolbar>
    <ng-container navStart>
      <button mat-icon-button (click)="sidenav().toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <button class="pwa-back-button" mat-icon-button (click)="navigateBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </ng-container>
    <ng-container navCenter>
      <div class="doublelined">
        <div class="webdoku showIfEmpty">{{ projectName }}</div>
        <div class="infotext showIfEmpty">{{ infoText }}</div>
      </div>
    </ng-container>
    <ng-container navEnd>
      <span class="spacer"></span>
      <div class="versiontext">{{ shortVersion }}</div>
    </ng-container>
  </lfw-navigation-toolbar>

  <mat-sidenav-container
    class="sidenav-container"
    [hasBackdrop]="hasBackdrop"
    (backdropClick)="closeBackdrop(true)"
    [autosize]="true">
    @if (isMenuVisible) {
      <mat-sidenav #sidenav opened="true" mode="side" disableClose>
        <mat-nav-list class="nav-list">
          @for (mitem of availableItems$ | async; track mitem.id) {
            <div>
              <a
                class="nav-list-item"
                mat-list-item
                [routerLink]="mitem.route"
                routerLinkActive="active-link"
                (click)="closeBackdrop(false)">
                <mat-icon>{{ mitem.icon }}</mat-icon>
                <span>&nbsp;{{ mitem.text }}</span>
              </a>
            </div>
          }
          <lfw-menu [menuItems]="userCommands$ | async">
            <a mat-list-item>
              <mat-icon>{{ menuService.cmdUser?.icon }}</mat-icon>
              <span>&nbsp;{{ menuService.cmdUser?.text }}</span>
            </a>
          </lfw-menu>
          <span class="spacer"></span>
          <span mat-list-item class="bottomtext">
            <mat-icon class="bar-icon">person</mat-icon>
            {{ userName }}
          </span>
        </mat-nav-list>
      </mat-sidenav>
    }

    <mat-sidenav-content class="main-outlet-container">
      <ng-content />
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
